// Third party libraries
import * as $ from 'jquery';

// Utils
import { vuelidateUtil } from '@/utils/vuelidate-util.js';

// Services
import ProductService from '@/app/services/main/product/product-service';
import BrandService from '@/app/services/main/brands/brand-service';

// Constants
import { STATUS_CODES} from '@/app/constants/constants.js';

// Mixins
import { toastMessageMixins } from '@/app/mixins/utils/toast-message-mixins';
import { inputTextMixins } from '@/app/mixins/utils/input-text-mixins';

export default {
	name: 'ModalAddEditBrand',
	mixins: [toastMessageMixins, inputTextMixins],
	props: {
		modalContent: {
			type: Object,
			required: true
		}
	},
	data() {
		return this.initializeModalData();
	},
	computed: {
		validationRules() {
			let fields = {
				selectedProductType: {},
				brandName: {}
			}

			fields = vuelidateUtil.setFieldsRequired(fields, true);

			return fields;
		},
		isInvalid() {
			if (this.modalContent.title === 'Add') {
				return this.$v.$invalid;
			} else {
				return (this.$v.$invalid || ( this.modalContent.brand.productType === this.selectedProductType && this.modalContent.brand.name === this.brandName));
			}
		},
	},
	watch: {
		selectedProductType(newVal) {
			if (newVal) {
				this.callCheckBrandName();
			}
		}
	},
	beforeDestroy() {
		this.hideModal();
	},
	methods: {
		initializeModalData() {
			return {
				productTypeOptions: [],
				isProductTypeLoading: false,
				nameDuplicateWarning: false,
				selectedProductType: '',
				brandName: '',
			}
		},
		getProductType() {
			this.isProductTypeLoading = true;

			ProductService.getProductTypes()
				.then(res => {
					if (res.status === STATUS_CODES.SUCCESS) {
						this.productTypeOptions = res.data;
					} else {
						this.showGenericErrorToast();
					}

					this.isProductTypeLoading = false;
				});
		},
		submitBrand(add) {
			const brandDetails = {
				productTypeId: this.selectedProductType.id,
				name: this.brandName
			}

			if (this.modalContent.title === "Add") {
				BrandService.addBrand(brandDetails)
					.then(res => {
						if (res.status === STATUS_CODES.SUCCESS_NO_CONTENT) {
							this.showCustomSuccessToast('Add Brand.', 'Successfully added brand.');

							if(add === 'add') {
								this.hideModal();
							} 

							this.clearFields('reset');
							this.$emit('getTableContent');
						} else {
							this.showAPIErrorToast('Error Adding Brand.', res);
						}

						this.isAPILoading = false;
					})
					.catch(() => {
							this.showGenericErrorToast();
							this.isAPILoading = false;
					});
				

			} else {
				BrandService.updateBrand(this.modalContent.brand.id, brandDetails)
					.then(res => {
						if (res.status === STATUS_CODES.SUCCESS_NO_CONTENT) {
							this.showCustomSuccessToast('Update Brand.', 'Successfully updated brand.');

							
							this.hideModal();
							this.clearFields();
							this.$emit('getTableContent');

						} else {
							this.showAPIErrorToast('Error Updating Brand.', res);
						}

						this.isAPILoading = false;
					})
					.catch(() => {
							this.showGenericErrorToast();
							this.isAPILoading = false;
					});

			}
		},
		callCheckBrandName() {
			// to do --------- check brand name if in use
			// const queryParams = {
			// 	f_name: this.brandName,
			// 	f_productType: this.selectedProductType.name,
			// 	isForTable: 'true'
			// }

			// BrandService.getBrands(queryParams)
			// 	.then(res => {
			// 		if (res.status === STATUS_CODES.SUCCESS) {
			// 			this.checkBrandName = res.data.data.lenght > 0;
			// 		} else {
			// 			this.showAPIErrorToast('Unable to fetch brands list.', res);
			// 		}
			// 	})
			// 	.catch(() => {
			// 		this.showGenericErrorToast();
			// 	});
		},
		nameKeyUp() {
			// to do --------- check brand name if in use
			// this.delayTyping(() => {
			// 	if (this.productName !== '') {
			// 		this.callCheckBrandName();
			// 	}
			// });
		},
		show() {
			// reset data on show
			this.clearFields();

			// show modal
			$(this.$refs.modalAddEditBrands).modal('show');

			// get breed list
			this.getProductType();

			// set fields for update
			if (this.modalContent.brand) {
				this.selectedProductType = this.modalContent.brand.productType;
				this.brandName = this.modalContent.brand.name;
			}
		},
		hideModal() {
			$(this.$refs.modalAddEditBrands).modal('hide');
        },
		clearFields(option) {
			if (option === 'reset') {
				this.selectedProductType = '';
				this.brandName = '';
			} else {
				Object.assign(this.$data, this.initializeModalData());
			}

			this.$v.$reset();
        },
		onBlur(field) {
			if (field === 'productType') {
				this.$v.selectedProductType.$touch();
			} else {
				this.$v.brandName.$touch();
			}
		},
	},
	validations() {
		return this.validationRules;
	}
}